import { useState } from 'react';
import { useIntl } from 'react-intl';

import type { HtmlSerializerProps } from '../../utils/html-serializer';
import htmlSerializer from '../../utils/html-serializer';

import type { BrazeCustomEvent } from './prescreen-consumer';

interface MetaLanguageSinglePageProps {
  content: HtmlSerializerProps['content'][];
  successContent?: HtmlSerializerProps['content'][];
  onClose: () => void;
  onButtonClick?: (buttonId: string) => void;
  onURLButtonClick: (
    url: string,
    target?: '_self' | '_blank',
    buttonId?: string
  ) => void;
  buttonColor?:
    | 'primary'
    | 'secondary'
    | 'overlay'
    | 'tertiary'
    | 'proBusiness'
    | 'premium'
    | 'proJobs';
  sendBrazeCustomEvent?: (payload: BrazeCustomEvent) => void;
}

export const MetaLanguageSinglePage: React.FC<MetaLanguageSinglePageProps> = ({
  content,
  successContent,
  onClose,
  onButtonClick,
  onURLButtonClick,
  sendBrazeCustomEvent,
  buttonColor,
}) => {
  const intl = useIntl();
  const [registrationSucceeded, setRegistrationSucceeded] = useState(false);
  const registrationForm = content.find(
    (contentItem) => contentItem.type === 'registrationForm'
  );
  const configuredSuccessContent = successContent?.length
    ? successContent
    : registrationForm?.type === 'registrationForm' &&
        registrationForm.successContent?.length
      ? registrationForm.successContent
      : undefined;
  const defaultSuccessContent: HtmlSerializerProps['content'][] = [
    { type: 'stickerBell', size: 'medium' },
    {
      type: 'headline',
      text: intl.formatMessage({
        id: 'BRAZE_POP_OVER_CONFIRMATION_HEADLINE',
        defaultMessage: 'Check your inbox',
      }),
      style: { size: 'large', textAlign: 'center' },
    },
    {
      type: 'paragraph',
      value: [
        {
          type: 'text',
          text: intl.formatMessage({
            id: 'BRAZE_POP_OVER_CONFIRMATION_COPY',
            defaultMessage:
              'We sent you an email to confirm your XING profile.',
          }),
        },
      ],
      style: { textAlign: 'center' },
    },
    {
      type: 'button',
      action: 'close',
      text: intl.formatMessage({
        id: 'BRAZE_POP_OVER_CONFIRMATION_CLOSE',
        defaultMessage: 'Got it',
      }),
      style: { textAlign: 'center' },
    },
  ];
  const visibleContent = registrationSucceeded
    ? (configuredSuccessContent ?? defaultSuccessContent)
    : content;

  const handleRegistrationSuccess = (): void => {
    setRegistrationSucceeded(true);
  };

  return (
    <>
      {visibleContent.map((contentItem, index) =>
        htmlSerializer({
          content: contentItem,
          key: `customHTML-${index}`,
          onClose,
          onButtonClick: registrationSucceeded ? undefined : onButtonClick,
          onURLButtonClick,
          buttonColor,
          sendBrazeCustomEvent,
          onRegistrationSuccess:
            !registrationSucceeded && registrationForm
              ? handleRegistrationSuccess
              : undefined,
        })
      )}
    </>
  );
};
